import axios from "axios"
import { API_URL } from "../../../js/Helper";

export  const validateAccessToken = async (data) => {
    const req = await axios.post(`${API_URL}/auth/validate-access-token`, data);

    return req;
}